declare module 'ckeditor5-premium-features' {
  import type { Editor, PluginConstructor } from 'ckeditor5'

  export const MultiLevelList: PluginConstructor<Editor>
}
